import { render, staticRenderFns } from "./LovedCombos.vue?vue&type=template&id=25aade16&scoped=true"
import script from "./LovedCombos.vue?vue&type=script&lang=js"
export * from "./LovedCombos.vue?vue&type=script&lang=js"
import style0 from "./LovedCombos.vue?vue&type=style&index=0&id=25aade16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aade16",
  null
  
)

export default component.exports